import { useSelector } from 'react-redux';
import {
  displayZeroSelector,
  hideDecimalsSelector,
  negativeMinusSelector,
} from '../userData/store/selectors';

export type UserNumberFormatterOptions = {
  negativeMinus: boolean,
  hideDecimals: boolean,
  displayZeros: boolean,
}

export const useUserNumberFormatterOptions = (): UserNumberFormatterOptions => {
  const negativeMinus = useSelector(negativeMinusSelector);
  const hideDecimals = useSelector(hideDecimalsSelector);
  const displayZeros = useSelector(displayZeroSelector);

  return {
    negativeMinus,
    hideDecimals,
    displayZeros,
  };
};
